import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeCheck = function SvgLargeCheck(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 69 68",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#large-check_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M59.51 11.364L24.378 46.59 8.511 30.68c-1.814-1.817-4.987-1.817-6.8 0-1.814 1.819-1.814 5 0 6.819l19.266 19.318c.907.91 2.267 1.364 3.4 1.364 1.134 0 2.494-.455 3.4-1.364l38.534-38.636c1.813-1.818 1.813-5 0-6.818-2.04-1.819-4.987-1.819-6.8 0z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "large-check_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h68v68H0z",
    transform: "translate(.35)"
  }))));
};

export default SvgLargeCheck;